import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

const customNumberKeys = [
  "customNumber1",
  "customNumber2",
  "customNumber3",
  "customAttributeNumber1",
  "customAttributeNumber2",
  "customAttributeNumber3",
] as const;

export function getCustomNumberCsvColumn(
  title: string,
  key: (typeof customNumberKeys)[number],
): FulfillmentGroupCsvColumn<FulfillmentGroupData> {
  return {
    header: title,
    cell: (row: FulfillmentGroupData) =>
      row[key] ? row[key].map((num: number) => num.toString()).join(", ") : "",
  };
}
